import { IconButton } from 'office-ui-fabric-react';
import styled from 'styled-components';

export const ModalCloseButton = styled(IconButton)`
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 6px;
  margin: 4px 2px auto auto;
  color: rgb(200, 198, 196);
  font-size: 18px;
  cursor: pointer;
  overflow: auto;
  &:focus,
  &.ms-Button:focus {
    outline: 1px solid rgb(200, 198, 196);
  }
  i {
    display: block;
  }
`;
